import { backgroundOrange } from '@/theme/colors'
import { AttachmentSection } from '@components/Attachments'
import Modal from '@components/Modal'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import IdeaForm from '../AddIdeaModal/IdeaForm'
import { ButtonGroup, CancelButton, SubmitButton } from '../AddIdeaModal/IdeaForm.styles'
import { emptyIdeaDraft, IdeaDraft, ideaDraftFrom, isIdeaDraftValid } from '../ideaForm'
import { Idea } from '../types'
import { TestIds } from '@/testIds'

interface EditIdeaModalProps {
	isOpen: boolean
	onClose: () => void
	onSubmit: (draft: IdeaDraft) => void
	onDelete?: () => void
	idea: Idea | null
}

const EditIdeaModal: React.FC<EditIdeaModalProps> = ({ isOpen, onClose, onSubmit, onDelete, idea }) => {
	const { tripId } = useParams<{ tripId: string }>()
	const [draft, setDraft] = useState<IdeaDraft>(emptyIdeaDraft)

	// The form opens on the idea as it stands.
	useEffect(() => {
		if (isOpen && idea) setDraft(ideaDraftFrom(idea))
	}, [isOpen, idea])

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		if (!isIdeaDraftValid(draft)) return
		onSubmit(draft)
		onClose()
	}

	const formId = 'edit-idea-form'

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Edit Idea"
			closeOnBackdropClick={false}
			backgroundColor={backgroundOrange}
			onDelete={onDelete}
			deleteTestId={TestIds.idea.deleteButton}
			footer={
				<ButtonGroup>
					<CancelButton type="button" onClick={onClose}>
						Cancel
					</CancelButton>
					<SubmitButton
						type="submit"
						form={formId}
						disabled={!isIdeaDraftValid(draft)}
						data-testid={TestIds.idea.submitButton}
					>
						Save Changes
					</SubmitButton>
				</ButtonGroup>
			}
		>
			<IdeaForm
				formId={formId}
				draft={draft}
				onDraftChange={setDraft}
				onSubmit={handleSubmit}
				attachmentSlot={
					tripId && idea ? (
						<AttachmentSection
							tripId={tripId}
							resourceType="IDEA"
							resourceId={idea.id}
							fileIds={idea.fileIds || []}
						/>
					) : undefined
				}
			/>
		</Modal>
	)
}

export default EditIdeaModal
